export default {
  dashboardPdfEditor: '/dashboard/pdf-editor',
};
